<script>
import InfoExclamationMark from "@/components/info/infoExclamationMark.vue"


export default {
  name: "FormSelectMultiple",
  directives: {

  },
  components: { InfoExclamationMark },
  emits: ["change", "customActionClicked"],
  props: {
    customActionText: {
      type: String,
      required: false,
      default: "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    infoText: {
      type: String,
      default: "",
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      required: true,
    },
    itemSubtext: {
      type: String,
      required: false,
      default: "",
    },
    itemText: {
      type: String,
      required: true,
    },
    itemValue: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    large: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    sideBox: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      required: true,
    },
    selectedBelow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    newItemText: "",
    isOpened: false,
  }),
  methods: {
    addNewItem() {
      if (!this.newItemText) {
        return
      }

      this.newItemText = this.newItemText.trim()
      if (this.newItemText === "") {
        return
      }

      this.$emit("change", [
        ...this.value,
        {
          [this.itemText]: this.newItemText,
          [this.itemValue]: this.newItemText,
        },
      ])

      this.newItemText = ""
    },
    handleChange(item) {
      if (
        this.value.find((it) => it[this.itemValue] === item[this.itemValue])
      ) {
        this.$emit(
          "change",
          this.value.filter((i) => i[this.itemValue] !== item[this.itemValue])
        )
      } else {
        this.$emit("change", [...this.value, item])
      }

      this.isOpened = false
    },
  },
}
</script>

<template>
  <div>
    <div
      class="position-relative"
      :class="{ 'side-box__row d-flex align-items-center mt-3': sideBox }"
    >
      <div
        v-if="label || customActionText"
        class="font-weight-light mb-1"
        :class="{
          'side-box__content__label mr-3 pr-1': sideBox,
          'text-left': !sideBox,
        }"
      >
        <span v-if="label">
          {{ label }}
        </span>
        <a @click.prevent="$emit('customActionClicked')">
          {{ customActionText }}
        </a>
      </div>
      <div
        v-click-outside="() => (isOpened = false)"
        class="custom-control__select w-100"
        :class="{ 'side-box__content__input': sideBox }"
      >
        <div
          class="custom-control__select__selected d-flex"
          :class="{ opened: isOpened, 'has-error': hasError }"
          @click="isOpened = !isOpened"
        >
          <div class="d-flex flex-wrap">
            <span
              v-if="(!value.length && !newItemText) || selectedBelow"
              :class="{ 'gray-text': !selectedBelow }"
            >
              {{ placeholder }}
            </span>
            <div v-else-if="!selectedBelow" class="d-flex selected-tags">
              <span
                v-for="(selectedItem, index) in value"
                :key="`${itemValue}${itemText}option${index}`"
                class="mr-1 atom-tag d-flex justify-content-between"
              >
                <span v-text="selectedItem[itemText]" />
                <img
                  src="@/assets/icons/actions/ico-ico-delete-light.svg"
                  alt=""
                  class="ml-2"
                  @click="handleChange(selectedItem)"
                />
              </span>
            </div>
            <input
              v-if="!selectedBelow"
              v-model="newItemText"
              type="text"
              class="tags"
              placeholder=""
              autofocus
              @blur="addNewItem"
              @keyup.enter.space="addNewItem"
            />
          </div>
        </div>
        <div
          class="custom-control__select__options"
          :class="{ opened: isOpened }"
        >
          <div
            v-for="item in items"
            :key="`${label}Option${item[itemValue]}`"
            class="custom-control__select__option d-flex align-items-center"
            @click="handleChange(item)"
          >
            <div class="mr-2" style="width: 1.5rem">
              <img
                v-show="value.find((it) => it[itemValue] === item[itemValue])"
                src="@/assets/icons/check.svg"
                alt=""
              />
            </div>
            <div class="d-flex justify-content-between w-100">
              <span class="font-weight-light">
                {{ item[itemText] }}
                <br />
                <span v-if="itemSubtext" class="text-smallest">
                  {{ item[itemSubtext] }}
                </span>
              </span>
            </div>
          </div>
          <div
            v-if="!items.length"
            class="custom-control__select__option d-flex align-items-center gray-text"
          >
            {{ $t("SELECT_NO_DATA") }}
          </div>
        </div>
      </div>
      <div
        v-if="selectedBelow && value.length"
        class="custom-control__selectedValues"
      >
        <div
          v-for="(item, index) in value"
          :key="index"
          class="d-flex align-items-start justify-content-between"
        >
          <div class="custom-control__selectedValues__value">
            {{ item[itemText] }}
          </div>
          <img
            class="custom-control__selectedValues__icon pointer"
            src="@/assets/icons/actions/ico-delete-2.svg"
            @click="handleChange(item)"
          />
        </div>
        <div
          v-if="!items.length"
          class="custom-control__select__option d-flex align-items-center gray-text"
        >
          {{ $t("SELECT_NO_DATA") }}
        </div>
      </div>
    </div>
    <info-exclamation-mark
      v-if="infoTooltip && infoTooltip"
      :info-text="infoText"
      :info-tooltip="infoTooltip"
    />
  </div>
</template>
